import { InputAdornment, Theme } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '../../../theme/theme';

const useStyles = makeStyles((theme: Theme) => ({
	errorMessage: {
		color: colors.red,
		fontSize: 14,
		marginLeft: 10,
		marginTop: 4,
		height: '2em',
	},
	input: {
		backgroundColor: 'white !important',
		color: colors.grayA80,
		fontSize: 14,
		filled: {
			backgroundColor: 'white',
		},
	},
	inputFocus: {
		backgroundColor: 'white',
	},
	adornedEnd: {
		backgroundColor: 'white',
	},
	textField: {
		width: '100%',
		marginRight: 0,
		height: 56,
	},
	dense: {
		marginTop: 0,
	},
	label: {
		marginLeft: 0,
		fontSize: 14,
		'&$labelFocused': {
			color: colors.grayA20,
		},
	},
	labelFocused: {},
	inputUnderline: {
		borderBottomColor: colors.grayA20,
		'&:after': {
			borderBottomColor: theme.palette.primary.main,
		},
	},
}));

export interface GenericInputProps {
	label: string;
	error?: string;
	inputId?: string;
	inputValue: string;
	endAdornement?: React.ReactNode;
	type?: string;
	additionalInputParams?: any; // TextFieldProps
	setInputValue(value: any): void;
	// toggleType?: boolean;
	toggleEditing?(value: string): any;
}

export const GenericInput: React.FC<GenericInputProps> = (props) => {
	const additionalInputParams = props.additionalInputParams || {};
	const classes = useStyles();
	const { t } = useTranslation();
	// turn off autocomplete in production env
	const autoComplete =
		additionalInputParams?.InputProps?.autoComplete ??
		process.env.NODE_ENV === 'production'
			? 'off'
			: null;

	return (
		<>
			<TextField
				error={Boolean(props.error && props.error !== '')}
				label={t(props.label)}
				className={classNames(classes.textField, classes.dense)}
				value={ props.inputValue }
				onBlur ={props.toggleEditing}
				onFocus={props.toggleEditing}
				onChange={(event) => {
					props.setInputValue(event.target.value);
				}}
				variant="filled"
				{...additionalInputParams}
				InputProps={{
					autoComplete,
					id: props.inputId ? props.inputId : '',
					type: props.type,
					classes: {
						root: classes.input,
						underline: classes.inputUnderline,
						inputAdornedEnd: classes.adornedEnd,
					},
					endAdornment: props.endAdornement ? (
						<InputAdornment position="end">
							{props.endAdornement}
						</InputAdornment>
					) : null,
					...additionalInputParams.InputProps,
				}}
				InputLabelProps={{
					classes: {
						root: classes.label,
						focused: classes.labelFocused,
					},
					...additionalInputParams.InputLabelProps,
				}}
			/>
			<div className={classes.errorMessage}>
				{props.error && props.error.trim() !== '' && props.error}
			</div>
		</>
	);
};
